export default __webpack_public_path__ + "static/media/Katsushika_Hokusai_Kamida_ga_taki_waterfall_50_x_70_cm.244e4cab.jpg";